/**
 * NicLen.Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PriorityLevel = 'Undefined' | 'VeryHigh' | 'High' | 'Normal' | 'Low' | 'VeryLow';

export const PriorityLevel = {
    Undefined: 'Undefined' as PriorityLevel,
    VeryHigh: 'VeryHigh' as PriorityLevel,
    High: 'High' as PriorityLevel,
    Normal: 'Normal' as PriorityLevel,
    Low: 'Low' as PriorityLevel,
    VeryLow: 'VeryLow' as PriorityLevel
};

